(function () {
  const MOBILE_QUERY = '(max-width: 768px)';
  const SCROLL_THRESHOLD = 8;

  class PdpMenuBar {
    constructor(root) {
      this.root = root;
      this.nav = root.querySelector('[data-nav]');
      this.buyBar = root.querySelector('[data-buy]');
      this.list = root.querySelector('[data-menu-list]');
      this.links = Array.from(root.querySelectorAll('[data-menu-button]'));
      this.addButtons = Array.from(root.querySelectorAll('[data-add-to-cart]'));
      this.priceNode = root.querySelector('[data-price]');
      this.compareNode = root.querySelector('[data-compare]');
      this.addLabel = root.dataset.addLabel || 'Add to Cart';
      this.soldOutLabel = root.dataset.soldOutLabel || 'Sold out';
      this.pageAtcInView = true;
      this.lastScrollY = window.scrollY || 0;
      this.wasMobile = window.matchMedia(MOBILE_QUERY).matches;
      this.productForm = null;
      this.pageSubmit = null;
      this.headerSection = document.querySelector('.section-header');
      this.promoBanner = document.querySelector(
        '.floating-promo-banner[data-place-above-header="true"], .floating-promo-banner[data-place-above-header="True"]'
      );

      this.onScroll = this.onScroll.bind(this);
      this.onResize = this.onResize.bind(this);
      this.onClick = this.onClick.bind(this);
      this.syncFromProduct = this.syncFromProduct.bind(this);

      this.bindProductForm();
      this.bindAddButtons();
      this.bindVariantSync();
      this.bindHeaderSync();
      this.updateTopOffset();
      this.updatePurchaseVisibility();
      this.updateActive();

      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onResize, { passive: true });
      root.addEventListener('click', this.onClick);
    }

    isMobile() {
      return window.matchMedia(MOBILE_QUERY).matches;
    }

    bindProductForm() {
      const productInfo = document.querySelector('product-info[id^="MainProduct-"]');
      if (!productInfo) {
        this.pageAtcInView = false;
        return;
      }

      this.productForm =
        productInfo.querySelector('.buy-buttons_xbloom product-form form[data-type="add-to-cart-form"]') ||
        productInfo.querySelector('product-form form[data-type="add-to-cart-form"]');
      this.pageSubmit = this.productForm ? this.productForm.querySelector('[type="submit"]') : null;

      if (!this.pageSubmit || typeof IntersectionObserver === 'undefined') {
        this.pageAtcInView = false;
        return;
      }

      this.atcObserver = new IntersectionObserver((entries) => {
        this.pageAtcInView = entries.some((entry) => entry.isIntersecting);
        this.updatePurchaseVisibility();
      });
      this.atcObserver.observe(this.pageSubmit);

      this.submitObserver = new MutationObserver(() => this.syncButtonState());
      this.submitObserver.observe(this.pageSubmit, {
        attributes: true,
        attributeFilter: ['disabled', 'class', 'aria-disabled'],
      });
      this.syncButtonState();
    }

    bindAddButtons() {
      this.addButtons.forEach((button) => {
        button.addEventListener('click', () => {
          if (!this.productForm || !this.pageSubmit) return;
          if (button.disabled || this.pageSubmit.disabled) return;
          if (this.pageSubmit.getAttribute('aria-disabled') === 'true') return;
          this.productForm.requestSubmit(this.pageSubmit);
        });
      });
    }

    bindHeaderSync() {
      const elements = [this.headerSection, this.promoBanner].filter(Boolean);
      if (!elements.length || typeof ResizeObserver === 'undefined') return;
      this.headerObserver = new ResizeObserver(() => this.updateTopOffset());
      elements.forEach((element) => this.headerObserver.observe(element));
    }

    bindVariantSync() {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.variantChange, () => {
          requestAnimationFrame(this.syncFromProduct);
        });
      }
    }

    syncFromProduct() {
      this.syncPrice();
      this.syncButtonState();
    }

    syncPrice() {
      if (!this.priceNode) return;
      const priceRoot = document.querySelector('product-info[id^="MainProduct-"] [data-product-price]');
      if (!priceRoot) return;

      const blocks = Array.from(priceRoot.querySelectorAll('.price-block'));
      const active =
        blocks.find((block) => window.getComputedStyle(block).display !== 'none') || blocks[0] || priceRoot;
      const priceEl = active.querySelector('.price');
      const onSale = priceEl && priceEl.classList.contains('price--on-sale');
      const current = onSale
        ? active.querySelector('.price-item--sale')
        : active.querySelector('.price__regular .price-item--regular');
      const compare = onSale ? active.querySelector('.price__sale .price-item--regular') : null;

      if (current) this.priceNode.textContent = current.textContent.trim();
      if (this.compareNode) {
        const compareText = compare ? compare.textContent.trim() : '';
        this.compareNode.textContent = compareText;
        this.compareNode.hidden = compareText === '';
      }
    }

    syncButtonState() {
      const submit = this.pageSubmit;
      const loading = !!(submit && submit.classList.contains('loading'));
      const soldOut = !!(submit && submit.disabled && !loading);

      this.addButtons.forEach((button) => {
        button.disabled = soldOut || loading;
        button.classList.toggle('is-loading', loading);
        button.setAttribute('aria-disabled', soldOut || loading ? 'true' : 'false');
        const label = button.querySelector('[data-label]');
        if (label) label.textContent = soldOut ? this.soldOutLabel : this.addLabel;
      });
    }

    pastFirstScreen() {
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      const scrollY = window.scrollY || document.documentElement.scrollTop || 0;
      return scrollY >= viewportHeight;
    }

    updatePurchaseVisibility() {
      const showPurchase = !this.pageAtcInView && this.pastFirstScreen();
      if (this.isMobile()) {
        this.setShown(this.buyBar, showPurchase);
        return;
      }

      this.setShown(this.buyBar, false);
      this.setShown(this.nav, showPurchase);
    }

    setShown(element, show) {
      if (!element) return;
      element.classList.toggle('is-visible', show);
      element.setAttribute('aria-hidden', show ? 'false' : 'true');
    }

    updateMobileMenu(scrollY) {
      if (!this.nav || !this.isMobile()) return;

      const delta = scrollY - this.lastScrollY;
      if (scrollY <= 2) {
        this.setShown(this.nav, false);
        this.lastScrollY = scrollY;
        return;
      }

      if (delta > SCROLL_THRESHOLD) this.setShown(this.nav, true);
      if (Math.abs(delta) >= SCROLL_THRESHOLD) this.lastScrollY = scrollY;
    }

    updateTopOffset() {
      if (!this.nav) return;
      if (!this.isMobile()) {
        this.nav.style.removeProperty('--pdp-menu-top-offset');
        return;
      }

      const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      const headerElements = [this.headerSection, this.promoBanner].filter(Boolean);
      const visibleBottom = headerElements.reduce((maxBottom, element) => {
        const rect = element.getBoundingClientRect();
        const bottom = Math.min(viewportHeight, Math.max(0, rect.bottom));
        return Math.max(maxBottom, bottom);
      }, 0);

      this.nav.style.setProperty('--pdp-menu-top-offset', `${Math.round(visibleBottom)}px`);
    }

    scrollOffset() {
      const header = document.querySelector('sticky-header, .section-header');
      let offset = header ? header.getBoundingClientRect().height : 0;
      if (this.isMobile() && this.nav && this.nav.classList.contains('is-visible')) {
        offset = Math.max(offset, this.nav.getBoundingClientRect().bottom);
      }
      return offset + 12;
    }

    onClick(event) {
      const button = event.target.closest('[data-menu-button]');
      if (!button || !this.root.contains(button)) return;

      const targetId = button.dataset.target;
      if (!targetId) return;
      const target = document.getElementById(targetId);
      if (!target) return;

      event.preventDefault();
      const top = target.getBoundingClientRect().top + window.pageYOffset - this.scrollOffset();
      window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
      this.setActive(button);
    }

    setActive(button) {
      this.links.forEach((link) => {
        const active = link === button;
        link.classList.toggle('is-active', active);
        link.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      this.scrollActiveIntoView(button);
    }

    scrollActiveIntoView(button) {
      if (!this.list || !button) return;
      const item = button.closest('.pdp-menu-bar__item') || button;
      const listRect = this.list.getBoundingClientRect();
      const itemRect = item.getBoundingClientRect();
      const nextLeft =
        this.list.scrollLeft + (itemRect.left - listRect.left) - (listRect.width - itemRect.width) / 2;
      this.list.scrollTo({ left: Math.max(0, nextLeft), behavior: 'smooth' });
    }

    updateActive() {
      if (!this.links.length) return;
      const marker = this.scrollOffset() + 24;
      let current = this.links[0];

      this.links.forEach((link) => {
        const target = document.getElementById(link.dataset.target);
        if (!target) return;
        if (target.getBoundingClientRect().top <= marker) current = link;
      });

      if (!current.classList.contains('is-active')) this.setActive(current);
    }

    onScroll() {
      if (this.ticking) return;
      this.ticking = true;
      requestAnimationFrame(() => {
        this.ticking = false;
        const scrollY = window.scrollY || document.documentElement.scrollTop || 0;
        this.updateTopOffset();
        this.updateMobileMenu(scrollY);
        this.updatePurchaseVisibility();
        this.updateActive();
      });
    }

    onResize() {
      const mobile = this.isMobile();
      if (mobile !== this.wasMobile) {
        if (mobile) this.setShown(this.nav, false);
        this.wasMobile = mobile;
        this.lastScrollY = window.scrollY || 0;
      }
      this.updateTopOffset();
      this.updatePurchaseVisibility();
      this.updateActive();
    }
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-pdp-menu-bar]').forEach((root) => {
      if (root.dataset.pdpMenuReady === 'true') return;
      root.dataset.pdpMenuReady = 'true';
      new PdpMenuBar(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
